import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import { SORTS } from "./tracksModel";

/** title and counts, character search, sort, Add Character */
export default function TracksToolbar({ stats, q, sort, busy, onQuery, onSort, onAdd, t }) {
  return (
    <div className="tk-toolbar">
      <div className="tk-title">
        <h2>{t("Characters")}</h2>
        <span className="tk-count">{stats}</span>
        {busy && <CircularProgress size={14} />}
      </div>
      <TextField
        className="tk-filter"
        size="small"
        type="search"
        placeholder={t("Find a character")}
        value={q}
        onChange={(e) => onQuery(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
          htmlInput: { "aria-label": t("Find a character") },
        }}
      />
      <TextField
        select
        className="tk-sort"
        size="small"
        value={sort}
        onChange={(e) => onSort(e.target.value)}
        slotProps={{
          select: { renderValue: (v) => t("Sort") + ": " + t(SORTS[v]), MenuProps: { className: "tk-menu" } },
          htmlInput: { "aria-label": t("Sort") },
        }}
      >
        {Object.keys(SORTS).map((k) => (
          <MenuItem key={k} value={k}>
            {t(SORTS[k])}
            {k === sort && <CheckIcon className="vv-menuCheck" />}
          </MenuItem>
        ))}
      </TextField>
      <Button className="tk-add" variant="outlined" size="small" endIcon={<AddIcon />} disabled={busy} onClick={onAdd}>
        {t("Add Character")}
      </Button>
    </div>
  );
}
